import React, { useMemo } from "react";
import { Checkbox, Input } from "antd";
import { Icon } from "Components";

interface PropertyOption {
  value: string;
  label: string;
  count: number;
}

interface Props {
  propertyOptions: PropertyOption[];
  selectedProperties: string[];
  setSelectedProperties: (properties: string[]) => void;
  propertySearchQuery: string;
  setPropertySearchQuery: (value: string) => void;
}

const PropertyRecipients: React.FC<Props> = ({
  propertyOptions,
  selectedProperties,
  setSelectedProperties,
  propertySearchQuery,
  setPropertySearchQuery,
}) => {
  const allSelected =
    propertyOptions.length > 0 &&
    selectedProperties.length === propertyOptions.length;

  const handleSelectAll = () => {
    if (allSelected) {
      setSelectedProperties([]);
    } else {
      setSelectedProperties(propertyOptions.map((p) => p.value));
    }
  };

  const handleToggle = (key: string) => {
    if (selectedProperties.includes(key)) {
      setSelectedProperties(selectedProperties.filter((p) => p !== key));
    } else {
      setSelectedProperties([...selectedProperties, key]);
    }
  };

  const totalCount = useMemo(
    () =>
      propertyOptions
        .filter((p) => selectedProperties.includes(p.value))
        .reduce((acc, p) => acc + p.count, 0),
    [propertyOptions, selectedProperties]
  );

  const filteredProperties = useMemo(
    () =>
      propertyOptions.filter((p) =>
        p.label.toLowerCase().includes(propertySearchQuery.toLowerCase())
      ),
    [propertyOptions, propertySearchQuery]
  );

  return (
    <div className="phishing-step3__property-section">
      <div className="phishing-step3__property-search">
        <Input.Search
          placeholder="Search properties"
          value={propertySearchQuery}
          onChange={(e: any) => setPropertySearchQuery(e.target.value)}
          suffix={<Icon type="search" />}
        />
      </div>

      <div className="phishing-step3__role-list-header">
        <div className="phishing-step3__label">
          Select properties ({propertyOptions.length}){" "}
          {totalCount > 0 && (
            <>
              <span className="phishing-step3__dot"> · </span>
              <span className="phishing-step3__total-count">
                {totalCount} users selected <span className="required">*</span>
              </span>
            </>
          )}
        </div>
        <button
          className="phishing-step3__select-all"
          onClick={handleSelectAll}
        >
          {allSelected ? "Deselect all" : "Select all"}
        </button>
      </div>

      <div className="phishing-step3__role-list">
        {filteredProperties.map((property) => (
          <div
            key={property.value}
            className="phishing-step3__role-item"
            onClick={() => handleToggle(property.value)}
          >
            <Checkbox
              checked={selectedProperties.includes(property.value)}
              onChange={() => handleToggle(property.value)}
              onClick={(e) => e.stopPropagation()}
            />
            <div className="phishing-step3__role-info">
              <div className="phishing-step3__role-title">
                <Icon type="recipientProperty" />
                {property.label}
              </div>
              <span className="phishing-step3__role-desc">
                {property.count} users
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PropertyRecipients;